import React from 'react';

const TabPane = (props) => {
    return (
        <div>
            { React.cloneElement(props.children, { 'isActive': props.isActive })}
        </div>
    );
}

TabPane.propTypes = {
    label    : React.PropTypes.string.isRequired,
    children : React.PropTypes.element.isRequired
}

export default TabPane;



// WEBPACK FOOTER //
// src/components/generic/tab-pane.js